import { useState } from "react"
import { Attachment, AttachmentUpload } from "../types/attachment"
import FilesModel, { FileFilers, ResponseArrayType } from "../models/files.model"

const useFiles = () => {
    const [files] = useState([])

    const getFiles = async (filters: FileFilers): Promise<ResponseArrayType> => {
        const response = await FilesModel.getFiles(filters)
        if(response.error){
            return {
                error: response.error
            }
        }

        return response
    }

    const updateFile = async (fileData: AttachmentUpload) : Promise<boolean> => {
        const response = await FilesModel.updateFile(fileData)
        if(response.error){
            return false
        }

        return true
    }

    const uploadFile = async (file: any, fileData: AttachmentUpload): Promise<Attachment | undefined> => {
      const response = await FilesModel.uploadFile(file, fileData)
      if(response.error){
        return undefined
      }

      return response.file
    }

    const deleteFile = async (fileId: number) : Promise<boolean> => {
        const response = await FilesModel.deleteFile(fileId)
        if(response.error){
            return false
        }

        return true
    }

    return {
        files,
        uploadFile,
        getFiles,
        deleteFile,
        updateFile
    }
}

export default useFiles